/**
 * useOrgReviewCount (GDN-2271)
 *
 * Lightweight count of pending org-review items. Drives both the count-gated
 * practice tab and the page-level empty-state gating. Uses `per_page: 1` (we
 * only need `total`) plus a polling interval so the tab count stays fresh while
 * a practice admin works, and skips entirely for users without the
 * `manage_subscription` permission so the provider endpoint is never called for
 * non-administrators.
 *
 * `enabled` gates the whole thing behind the `org_migration_review` feature gate
 * (GDN-2298): when off, the query is skipped so gated-off admins never poll.
 */

import { useCan } from '@features/user';

import { useListOrgReviewItemsQuery } from '../store/hooks';

const POLL_INTERVAL_MS = 30_000;

export function useOrgReviewCount(enabled = true): number {
  const canManageSubscription = useCan('manage_subscription');
  const { data } = useListOrgReviewItemsQuery(
    { perPage: 1 },
    {
      skip: !enabled || !canManageSubscription,
      pollingInterval: POLL_INTERVAL_MS,
    },
  );
  return data?.total ?? 0;
}
